import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

export default function Breadcrumb({ items = [] }) {
  return (
    <nav data-testid="breadcrumb" aria-label="Breadcrumb" className="bg-white border-b border-slate-100">
      <ol className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center gap-2 text-xs sm:text-sm text-slate-500">
        <li>
          <Link to="/" className="hover:text-primary inline-flex items-center gap-1">
            <Home className="w-3.5 h-3.5" /> Home
          </Link>
        </li>
        {items.slice(1).map((it, i) => (
          <li key={i} className="inline-flex items-center gap-2">
            <ChevronRight className="w-3.5 h-3.5 text-slate-300" />
            {it.to ? (
              <Link to={it.to} className="hover:text-primary">{it.label}</Link>
            ) : (
              <span className="text-slate-900 font-medium">{it.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
